import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const occasionFragment = `
    on ${QueryType.product} {
        occasion {
            key
            value
        }
    }
`;

export const occasionProductFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: occasionFragment
    };
};
